<div class="row pz-1">
    <div class="col-md-4 mb-3 p-1">
        <div class="notes">
            <div class="content">
                <h2>Inernal Notes Management</h2>
                <a class="btn btn-primary" (click)="openINMModule()">Know More</a>
                
            </div>
            <img src="../assets/images/notes-management.jpg" alt="">
        </div>
    </div>
    <div class="col-md-4 mb-3 p-1">
        <div class="notes">
            <div class="content">
                <h2>Meeting Management</h2>

                <a class="btn btn-primary"  (click)="openMMModule()">Know More</a>
            </div>
            <img src="../assets/images/notes-management.jpg" alt="">
        </div>
    </div>
    <div class="col-md-4 mb-3 p-1">
        <div class="notes">
            <div class="content">
                <h2>Circular Resolutions</h2>
      
                <a class="btn btn-primary" (click)="openCRModule()">Know More</a>
            </div>
            <img src="../assets/images/notes-management.jpg" alt="">
        </div>
    </div>
</div>